import { MaterialManager } from "../../material/MaterialManager";
import { AddonManager } from "../../scene/addon/AddonManager";
import { Vector3, Mesh, Object3D } from "three";

export interface ICornerBoxTrimConfig
{
	parent: Object3D;
	flip: boolean;
}

/**
 * Corner Box on the roof at the intersection of EaveTrim and SlopeTrim
 */
export class CornerBoxTrim
{

	private _config : ICornerBoxTrimConfig;
	private _mesh   : Mesh;

	constructor(config:ICornerBoxTrimConfig)
	{
		this._config = config;
		this.init();
	}

	private init()
	{
		var meshName = "Corner Box - Generic";

		if (this._config.flip)
		{
			meshName += "_flipped";
		}

		var material = MaterialManager.getInstance().trim;
		this._mesh = AddonManager.getInstance().createMesh(meshName, material) as Mesh;
		this._mesh.rotation.y = Math.PI;
		this._config.parent.add(this._mesh);
	}

	public update(position:Vector3, pitch:number)
	{
		var tan = pitch/12;
		var alpha = Math.atan(tan);

		this._mesh.position.set(position.x, position.y, position.z);
		this._mesh.rotation.z = -alpha;
	}
	public hide()
	{
		this._config.parent.remove(this._mesh);
	}

	public show()
	{
		this._config.parent.add(this._mesh);
	}
}